import { graphql } from "gql";

const REMOVE_FROM_MESSAGE_THREAD_DRY_RUN_QUERY = graphql(`
  query RemoveFromMessageThreadDryRun(
    $messageThreadId: ID!
    $input: RemoveFromMessageThreadDryRunInput!
  ) {
    removeFromMessageThreadDryRun(
      messageThreadId: $messageThreadId
      input: $input
    ) {
      ...RemoveFromMessageThreadDryRunOutput
    }
  }
`);

export default REMOVE_FROM_MESSAGE_THREAD_DRY_RUN_QUERY;
